<div class="metadata-block">
    <div>
        <div class="metadata-title">Template</div>
        <div><textarea rows="5" #userValue (change)="getUserValue(userValue.value)"
                class="json-template">{{prettyJsonTemplate}}</textarea>
        </div>
    </div>
    <div *ngIf="!isQuestionSelected">
        <div class="metadata-title">Conditionals</div>
        <div>
            <div class="metadata-key">Conditional Type</div>
            <select class="metadata-input-block" [(ngModel)]="conditionalType" (ngModelChange)="getConditionalData($event)">
                <option ngValue="Manual" selected>Manual entry</option>
                <option ngValue="Hide based on one option">Hide based on one option</option>
                <option ngValue="Show based on one option">Show based on one option</option>
            </select>
        </div>
        <div>
            <div class="metadata-key">Related Primitive</div>
            <select [disabled]="conditionalType === 'Manual'" class="metadata-input-block"
                [(ngModel)]="selectedRelatedPrimitive" (ngModelChange)='getAllPrimitiveOptions($event)'>
                <option ngValue="">Select Related Primitives</option>
                <option *ngFor="let primitive of relatedPrimitives" [ngValue]="primitive">
                    {{primitive}}
                </option>
            </select>
        </div>
        <div>
            <div class="metadata-key">Primitive Options</div>
            <select [disabled]="conditionalType === 'Manual'"
                class="metadata-input-block" [(ngModel)]="selectedPrimitiveOption"
                (ngModelChange)="getNewTemplate($event)">
                <option ngValue="" selected>Select Primitives Options</option>
                <option *ngFor="let option of primitiveOptions" [ngValue]="option.label">
                    {{option.label}}
                </option>
            </select>
        </div>
        <div>
            <div class="metadata-key">Additional Parameter</div>
            <div class="metadata-input-block">
                <mat-icon matPrefix class="metadata-input-icon">mode_edit</mat-icon>
                <input fxFlex="flex-grow" disabled="true" class="metadata-input-field" type="text"
                    placeholder="Additional Parameter" />
            </div>
        </div>
    </div>
</div>